import { render, staticRenderFns } from "./BrandLogosWidgetCarouselLayout.vue?vue&type=template&id=4ce9075e&scoped=true"
import script from "./BrandLogosWidgetCarouselLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./BrandLogosWidgetCarouselLayout.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BrandLogosWidgetCarouselLayout.vue?vue&type=style&index=0&id=4ce9075e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce9075e",
  null
  
)

export default component.exports